import axios from "axios"
import axiosInstance from "../models/axiosInstance"
import { API, BOOKING_API, GIFTCARD_API } from "./apiUrls"

//Shop Booking
export const createShopBooking = async (parms) => {
  const response = await axiosInstance.post(API.CREATE_SHOP_BOOKING(), parms)
  return response.data
}

//Mobile Booking
export const createMobileBooking = async (parms) => {
  // console.log(parms);
  const response = await axiosInstance.post(API.CREATE_MOBILE_BOOKING(), parms)
  return response.data
}

//upload Image
export const uploadImage = async (parms) => {
  const data = new FormData()
  for (let i = 0; i < parms.length; i++) {
    data.append("images", parms[i])
  }

  const response = await axiosInstance.post(API.UPLOAD_IMAGE(), data)
  return response.data
}

//calculatePricing
export const calculatePricing = async (request) => {
  const response = await axiosInstance.post(
    API.CALCULATE_SHOP_PRICING(),
    request,
  )
  return response.data
}

//get slots
export const getBookingSlots = async (request) => {
  const response = await axiosInstance.post(API.GET_BOOKING_SLOTS(), request)
  return response.data
}

// get discount
export const getDiscount = async (request) => {
  const response = await axiosInstance.post(API.GET_DISCOUNT(), request)
  return response.data
}

export const getPublicCoupon = async (request) => {
  const response = await axiosInstance.post(API.GET_PUBLIC_COUPON(), request)
  return response.data
}

// get discount
export const getConnectServer = async () => {
  const response = await axios.get("https://sys.boostceramic.ca/")
  return response.data
}

// V2
export const getVehicleOptions = async (location) => {
  const response = await axiosInstance.post(BOOKING_API.GET_VEHICLE_OPTIONS(), {
    locationType: location,
  })
  return response.data
}

export const getServiceOptions = async (location, vehicleId) => {
  const response = await axiosInstance.post(BOOKING_API.GET_SERVICe_OPTIONS(), {
    locationType: location,
    id: vehicleId,
  })
  return response.data
}

export const getBookingAllSlots = async (request) => {
  const response = await axiosInstance.post(
    BOOKING_API.GET_BOOKING_SLOTS(),
    request,
  )
  return response.data
}

export const createGuestBooking = async (parms) => {
  const response = await axiosInstance.post(BOOKING_API.CREATE_BOOKING(), parms)
  return response.data
}

export const purchseGiftcard = async (params) => {
  const response = await axiosInstance.post(
    GIFTCARD_API.PURCHASE_GIFTCARD(),
    params,
  )
  return response.data
}

export const viewGiftcard = async (params) => {
  const response = await axiosInstance.get(GIFTCARD_API.VIEW_GIFTCARD(params))
  return response.data
}

export const viewBooking = async (params) => {
  const response = await axiosInstance.get(BOOKING_API.VIEW_BOOKING(params))
  return response.data
}

export const getInvoiceData = async (params) => {
  const response = await axiosInstance.get(API.GET_PUBLIC_INVOICE(params))
  return response.data
}

export const publicPaymentInvoice = async (params) => {
  const response = await axiosInstance.post(API.PAYMENT_PUBLIC_INVOICE(),params)
  return response.data
}
